import React from 'react'

// Components
import Blog from 'components/flex/Posts/Blog'
import Projects from 'components/flex/Posts/Highlighted/Projects'

interface HighlightedShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_HighlightedPostTypes
  location?: any
}

interface PostProps {
  [key: string]: any
}

const HighlightedShell: React.FC<HighlightedShellProps> = ({
  fields,
  location = {},
}) => {
  const types: PostProps = {
    blog: Blog,
    projects: Projects,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default HighlightedShell
